import React from "react";
import { Grid, CardContent, CardHeader, Card, Divider, Fab } from "@material-ui/core";
import OrdersTable from "./OrderBookTable";
import AddIcon from "@material-ui/icons/Add";
import { usePageStyles } from "../../pageStyles";
import { PageComponent, AccessRights } from "../../../core/navigation/types";
import { PageTitle } from "../../components/common/PageTitle";
import { useOrderBookData } from "../../../data/trading/orderBook/hooks/useOrderBookData";
import { useOrderBookIndex } from "../../../data/trading/orderBook/hooks/useOrderBookIndex";
import { useHistory } from "react-router-dom";
import { getOrderEditLocation } from "../mainBoard/Locations";
import { PageDataStatus } from "../../../data/models";
import { OrderBookFilterButton } from "./OrderBookFilter";
import { useAuth } from "../../../data/auth/hooks";
import { useNotificationHandler } from "../../../core/notifications/hooks";
import moment from "moment";

const OrderBook: PageComponent = ({ userAccessRights }) => {
	const pageStyles = usePageStyles();

	const [pageData, dispatchLoadOrders, invalidateData] = useOrderBookData();
	const [pageIndex, dispatchSetIndex] = useOrderBookIndex();

	React.useEffect(() => {
		if (pageData && pageData.status === PageDataStatus.DataInvalidated) {
			dispatchLoadOrders();
		}
	}, [dispatchLoadOrders, pageData]);

	React.useEffect(() => () => { invalidateData() }, [])

	const history = useHistory();

	const [auth] = useAuth();

	useNotificationHandler<string>(
		"OrderChanged",
		e => {
			console.log("OrderChanged", e);
			invalidateData();
		},
		[]
	);

	if (auth.status !== "successful") {
		return null;
	}

    const radnovreme =  moment().hour()>8 && moment().hour()<14
	console.log(radnovreme)

	return (
		<>
			<Grid container className={pageStyles.root}>
				<Grid item xs={12} className={pageStyles.gridItem}>
					<Card>
						<CardHeader
							title={<PageTitle title="listingOrdersBookTitle" />}
							action={<OrderBookFilterButton />}
						/>
						<Divider />
						<CardContent>
							<OrdersTable
								pageIndex={pageIndex}
								pageData={pageData}
								onPageIndexChange={dispatchSetIndex}
								userAccessRights={userAccessRights}
								getData={dispatchLoadOrders}
							/>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
			{userAccessRights === AccessRights.All && (auth.user.roleCode === "BROKER" || auth.user.roleCode === "MEMTRADER" || auth.user.roleCode === "MEMMANAGER"
			 || auth.user.roleCode === "MEMCONTACT") &&   (
				<Fab
					color="secondary"
					aria-label="add"
					className={pageStyles.mainFab}
					onClick={() => history.push(getOrderEditLocation())}
				>
					<AddIcon />
				</Fab>
			)}
		</>
	);
};

export default OrderBook;
